// Server-built email bodies reference the logo by a URL that does not resolve inside a
// preview iframe, so swap in the app's own copy (legacy and current template).
export const fixEmailLogos = (html: string) => {
  const logoUrl = `${window.location.origin}/rec-logo.png`
  return html
    .replace(
      /<div class="logo">[\s\S]*?<\/div>/i,
      `<div class="logo"><img src="${logoUrl}" alt="Recruspin Logo" width="20" /></div>`
    )
    .replace(
      /<div class="recruspin-logo">[\s\S]*?<\/div>/i,
      `<div class="recruspin-logo"><img src="${logoUrl}" alt="recruspin logo" width="27" /></div>`
    )
}
